<template>
    <v-expansion-panel class="news-entry">

        <!-- title -->
        <v-expansion-panel-title>
            <div class="news-entry-date">
                <slot name="date"></slot>
            </div>
            <div class="news-entry-title">
                <slot name="title"></slot>
            </div>
        </v-expansion-panel-title>
    
        <!-- content -->
        <v-expansion-panel-text>
            <div class="news-entry-content">
                <div class="teaser">
                    <img :src="image" />
                </div>
                <div class="text">
                    <slot name="text"></slot>
                    <v-btn 
                        v-if="hasRoute"
                        class="button" 
                        variant="tonal" 
                        color="color1" 
                        @click="handleClick">
                        Open&nbsp;{{ route.name }}
                    </v-btn>
                </div>
            </div>
        </v-expansion-panel-text>

    </v-expansion-panel>
</template>

<script>
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'

export default {
    name: 'NewsEntry',
    props: {
        image: {
            type: String,
            required: false,
            default: null
        },
        route: {
            type: Object,
            required: false,
            default: null
        }
    },
    computed: {
        hasRoute() {
            return this.route !== null && this.route !== undefined
        }
    },
    methods: {
        ...mapActions('router', [
            'openRoute'
        ]),
        handleClick() {
            this.openRoute({ route: this.route })
        }
    }
}
</script>

<style>
.news-entry .v-expansion-panel-text__wrapper {
    padding: 0px;
}    
</style>

<style scoped>
.news-entry {
    border: 1px solid rgb(var(--v-theme-lightbase));
    border-bottom: none;
    background-color: rgb(var(--v-theme-darkbase));
}

.news-entry:last-child {
    border-bottom: 1px solid rgb(var(--v-theme-lightbase));
}

.news-entry-date {
    flex: 0 0 7ch;
    font-size: 0.9rem;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
    color: rgb(var(--v-theme-secondary));
}

.news-entry-title {
    flex: 1;
    min-width: 0;
    font-size: 1.1rem;
    margin-left: 25px;
    color: rgb(var(--v-theme-primary));
}

.news-entry-content {
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding: 10px;
    background: linear-gradient(
        to bottom, 
        rgb(var(--v-theme-darkerbase)),
        rgb(var(--v-theme-darkbase))
    );
}

.news-entry-content .teaser {
    max-width: 300px;
    aspect-ratio: 1 / 1;
    border-radius: 8px;
    overflow: hidden;
}

.news-entry-content .teaser img {
    width: 100%;
    object-fit: cover;
    object-position: center;
    image-rendering: auto;
}

.news-entry-content .text {
    padding: 50px;
    flex: 1;
    font-size: 1rem;
    color: rgb(var(--v-theme-secondary));
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 25px;
}

@media (max-width: 800px) {
    .news-entry-date {
        display: none;
    }

    .news-entry-title {
        margin-left: 0px;
    }

    .news-entry-content .teaser {
        max-width: 200px;
    }

    .news-entry-content .text {
        padding: 20px;
    }
}

@media (max-width: 600px) {
    .news-entry-content .teaser {
        width: 100%;
        max-width: unset;
    }

    .news-entry-content {
        flex-direction: column;
        gap: 0px;
    }
}
</style>
